module.exports = __webpack_public_path__ + "7c4f8b9f86684cfeca15d9457dd2c653.obj";